var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m15.491 6.823-4.54 5.77-2.44-2.44"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.458 1.458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.401 12.436 0 18.317l3.53-.598 1.224 3.364 3.01-5.056m9.919-3.591 3.4 5.881-3.53-.598-1.224 3.364-3.01-5.056"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.542,
    cy: 8.25,
    r: 8.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.8ddf0abf.svg";
export { ForwardRef as ReactComponent };